import { hasProperty } from '../hasProperty';
const isErrorWithMessage = error => hasProperty(error, 'message') && typeof error.message === 'string';
const toErrorWithMessage = maybeError => {
  if (isErrorWithMessage(maybeError)) {
    return maybeError;
  }
  try {
    return new Error(JSON.stringify(maybeError));
  } catch {
    return new Error(String(maybeError));
  }
};
export const getErrorMessage = error => toErrorWithMessage(error).message;